import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { I18nProvider } from "./contexts/I18nContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AnimalTypeProvider } from "./contexts/AnimalTypeContext";
import MobileBottomNav from "./components/thqah/MobileBottomNav";
import SupportFab from "./components/thqah/SupportFab";
import { Toaster } from "./components/ui/sonner";
import AppRoutes from "./routes/AppRoutes";
import AuthCallback from "./pages/AuthCallback";
import ErrorBoundary from "./components/ErrorBoundary";

import "./App.css";

// Auth-only screens render inside the same phone column, no bottom nav.
const AUTH_ONLY = ["/login", "/register", "/forgot-password", "/reset-password"];
// Landing renders full-width on desktop (DesktopHero needs the whole viewport).
const FULL_WIDTH_DESKTOP = ["/"];

function isAuthOnly(pathname) {
  return AUTH_ONLY.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

function isFullWidthDesktop(pathname) {
  return FULL_WIDTH_DESKTOP.includes(pathname);
}

function Shell() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;

  const authOnly = isAuthOnly(loc.pathname);
  const fullWidth = isFullWidthDesktop(loc.pathname);

  return (
    <div className="relative min-h-screen">
      {/* Phone column on mobile; on desktop, Landing breaks out to full-width while inner sections stay centered. */}
      <div
        className={`mx-auto w-full min-h-screen relative ${
          fullWidth
            ? "" // landing: no border, no max-width — DesktopHero handles its own layout
            : "md:max-w-md md:border-x md:border-[#D4AF37]/15 md:shadow-[0_0_80px_rgba(212,175,55,0.08)]"
        }`}
        data-testid="app-shell"
      >
        <main className={authOnly ? "min-h-screen" : "pb-28"}>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </main>
        {!authOnly && <MobileBottomNav />}
        {!authOnly && <SupportFab />}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <ThemeProvider>
          <AnimalTypeProvider>
            <AuthProvider>
              <BrowserRouter>
                <Shell />
                <Toaster position="bottom-right" richColors />
              </BrowserRouter>
            </AuthProvider>
          </AnimalTypeProvider>
        </ThemeProvider>
      </I18nProvider>
    </div>
  );
}
